<template>
  <div class="">
    <nav class="navbar navbar-light bg-light fixed-top blue-thick">
      <div class="col-md-12">
        <div class="row d-flex justify-content-center">
          <div class="col-md-3 ml-0 pl-0">
            <router-link to="" class="no-active">
              <img
                src="@/assets/adminlte/images/logo.png"
                class="img-fluid"
                alt=""
              />
            </router-link>
          </div>
        </div>
      </div>
    </nav>
    <section class="login-bg">
      <div class="row d-flex justify-content-center">
        <div class="col-md-5">
          <div style="background-color: #fff; opacity: 100%; margin-top: 130px">
            <div class="card-body login-card-body">
              <div class="row">
                <div class="col-md-3">
                  <div class="input-group mb-2">
                    <select class="form-control" v-model="title">
                      <option value="Mr">Mr</option>
                      <option value="Ms">Ms</option>
                      <option value="Mrs">Mrs</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-9">
                  <div class="input-group">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Name*"
                      v-model="name"
                    />
                    <div class="input-group-append">
                      <div class="input-group-text">
                        <span class="fas fa-user"></span>
                      </div>
                    </div>
                  </div>
                  <strong
                    style="font-size: 12px"
                    class="text-danger"
                    v-if="errors.name"
                    >{{ this.errors.name[0] }}</strong
                  >
                </div>
              </div>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  v-model="phone"
                  placeholder="Phone"
                />
                <div class="input-group-append">
                  <div class="input-group-text">
                    <span class="fas fa-phone"></span>
                  </div>
                </div>
                <span class="text-danger" v-if="errors.phone">{{
                  this.errors.phone[0]
                }}</span>
              </div>
              <div class="input-group mt-2">
                <input
                  id="email"
                  type="email"
                  class="form-control"
                  placeholder="Email*"
                  v-model="email"
                />
                <div class="input-group-append">
                  <div class="input-group-text">
                    <span class="fas fa-envelope"></span>
                  </div>
                </div>
              </div>
              <strong
                style="font-size: 12px"
                class="text-danger"
                v-if="errors.email"
                >{{ this.errors.email[0] }}</strong
              >
              <div class="input-group mt-2">
                <select class="form-control" v-model="industry">
                  <option value="">Select Industry*</option>
                  <option v-for="industry in industries" :value="industry">
                    {{ industry }}
                  </option>
                </select>
                <div class="input-group-append">
                  <div class="input-group-text">
                    <span class="fas fa-industry"></span>
                  </div>
                </div>
              </div>
              <strong
                style="font-size: 12px"
                class="text-danger"
                v-if="errors.industry"
                >{{ this.errors.industry[0] }}</strong
              >
              <div class="input-group mt-2">
                <select class="form-control" v-model="leadership">
                  <option value="">Select Leadership/Rank Level</option>
                  <option value="Frontline operator">Frontline operator</option>
                  <option value="Entry-level individual contributor">
                    Entry-level individual contributor
                  </option>
                  <option value="Experienced individual contributor">
                    Experienced individual contributor
                  </option>
                  <option value="Senior-level individual contributor">
                    Senior-level individual contributor
                  </option>
                  <option value="Entry-level manager">
                    Entry-level manager
                  </option>
                  <option value="Middle manager">Middle manager</option>
                  <option value="Senior manager">Senior manager</option>
                  <option value="Executive">Executive</option>
                </select>
                <div class="input-group-append">
                  <div class="input-group-text">
                    <span class="fas fa-book-reader"></span>
                  </div>
                </div>
              </div>
              <strong
                style="font-size: 12px"
                class="text-danger"
                v-if="errors.leadership"
                >{{ this.errors.leadership[0] }}</strong
              >
              <div class="input-group mt-2">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Location*"
                  v-model="location"
                />
                <div class="input-group-append">
                  <div class="input-group-text">
                    <span class="fas fa-street-view"></span>
                  </div>
                </div>
              </div>
              <strong
                style="font-size: 12px"
                class="text-danger"
                v-if="errors.location"
                >{{ this.errors.location[0] }}</strong
              >
              <div class="input-group mt-2 mb-2">
                <select name="country" class="form-control" v-model="country">
                  <option value="">Select Country*</option>
                  <option v-for="country in countries" :value="country.id">
                    {{ country.nicename }}
                  </option>
                </select>
                <div class="input-group-append">
                  <div class="input-group-text">
                    <span class="fas fa-globe-asia"></span>
                  </div>
                </div>
              </div>
              <strong
                style="font-size: 12px"
                class="text-danger"
                v-if="errors.country"
                >{{ this.errors.country[0] }}</strong
              >
              <vue-recaptcha
                :sitekey="siteKey"
                :loadRecaptchaScript="true"
                ref="recaptcha"
                type="invisible"
                @verify="onCaptchaVerified"
                @expired="onCaptchaExpired"
              >
              </vue-recaptcha>
              <span class="text-danger" v-if="errors.recaptcha"
                >Google captcha validation failed.</span
              >

              <div class="row">
                <div class="col-12 mt-2 mb-3">
                  <input
                    type="checkbox"
                    id="check_id"
                    value="1"
                    v-model="privacy_policy"
                  />
                  <span style="color: #495057" class="ml-2"
                    >I certify that I am 18 years old or older and that I have
                    read and agree to Lean Coach’s
                    <router-link to="/privacy-policy"
                      >Privacy Policy</router-link
                    ></span
                  >
                </div>
                <div class="col-6">
                  <router-link
                    to="/login"
                    class="btn btn-outline-primary btn-block"
                    >Login <i class="fas fa-sign-in-alt"></i
                  ></router-link>
                </div>
                <div class="col-6 mb-3">
                  <button
                    type="submit"
                    class="btn btn-primary btn-block"
                    :disabled="
                      captch_response_token == null || !privacy_policy || loader
                    "
                    @click="login"
                  >
                    <b-spinner small v-if="loader"></b-spinner>
                    <span class="ml-2" v-if="loader">Loading...</span>
                    <span v-if="!loader">
                      Register <i class="fas fa-check ml-1"></i>
                    </span>
                  </button>
                </div>
              </div>
              <div class="row mb-2 d-flex align-items-center">
                <!-- <div class="col-8">
                  <div class="icheck-primary">
                    <input type="checkbox" id="remember" />
                    <label for="remember" class="pl-2">Remember Me </label>
                  </div>
                </div> -->
                <!-- /.col -->
                <!-- <div class="col-4">
                  <button type="submit" class="btn" @click="login">
                    <b-spinner
                      style="margin-left: 60px"
                      v-if="loader"
                      variant="primary"
                      label="Spinning"
                    ></b-spinner>
                    <img
                      v-if="!loader"
                      src="@/assets/site/images/login.svg"
                      class="svg-btn1"
                      alt=""
                    />
                  </button>
                </div> -->
                <!-- /.col -->
              </div>

              <!-- /.social-auth-links -->
              <!-- <div class="row d-flex justify-content-between">
                <div class="col-xs-12 col-md-9 d-flex justify-content-end mx-0">
                  <p class="mb-1">
                    <router-link to="/register" class="text-center" href=""
                      >Register</router-link>
                      <router-link to="/forgot-password" class="text-center" href="">| Forgot User ID
                      or Password</router-link
                    >
                  </p>
                </div>

                <div class="col-xs-9 col-md-8">
                  <p class="mb-0">
                     
                  </p>
                  </p>
                </div>
              </div> -->
            </div>
            <!-- /.login-card-body -->
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import Vue from "vue";
import VueCompositionAPI from "@vue/composition-api";
Vue.use(VueCompositionAPI);

import { VueRecaptcha } from "vue-recaptcha";
const { ref, reactive } = VueCompositionAPI;
export default {
  name: "RegisterView",
  components: { "vue-recaptcha": VueRecaptcha },
  data() {
    return {
      siteKey: process.env.VUE_APP_GOOGLE_RECAPTCHA_KEY,
      liveid_recaptcha: 0, // will be used later
      captcha_verified: false,
      captch_response_token: null,
      privacy_policy: false,
      email: null,
      password: null,
      errors: [],
      loader: false,
      countries: [],
      industries: [
        "Accounting",
        "Agriculture",
        "Aerospace",
        "Automotive",
        "Chemical",
        "Construction",
        "Consulting",
        "Data Analytics",
        "Defense",
        "Education",
        "Electronics",
        "Energy",
        "Engineering",
        "Entertainment",
        "Fulfillment",
        "Finance",
        "Food",
        "Government",
        "Healthcare",
        "Human Resources",
        "Information Technology",
        "Law Enforcement",
        "Logistics",
        "Loss Prevention",
        "Manufacturing",
        "Marketing",
        "Mining",
        "Petroleum",
        "Research",
        "Retail",
        "Robotics",
        "Security",
        "Software",
        "Steel",
        "Supply Chain",
        "Telecommunications",
        "Transportation",
        "Services",
        "Warehouse",
      ],
      title: "Mr",
      name: null,
      phone: null,
      email: null,
      industry: "",
      leadership: "",
      location: null,
      country: "",
    };
  },
  created() {
    this.getCountries();
  },
  methods: {
    onCaptchaVerified: function (recaptchaToken) {
      this.captcha_verified = true;
      this.captch_response_token = recaptchaToken;
    },
    onCaptchaExpired: function () {
      this.captcha_verified = false;
      this.captch_response_token = null;
      this.$refs.recaptcha.reset();
    },
    getCountries() {
      let apiUrl = process.env.VUE_APP_URL + "api/getCountries";
      fetch(apiUrl, {
        method: "get",
        headers: {
          "content-type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
          "Acces-Control-Allow-Origin": "*",
        },
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.status) {
            this.countries = data.countries;
          } else {
            this.countries = [];
          }
        })
        .catch(function (err) {
          console.log("User Data", "Error : " + err.message, "error");
        });
    },
    login() {
      //Save or update User Details
      this.errors = [];
      this.loader = true;
      let apiUrl = process.env.VUE_APP_URL + "api/register";
      let method_type = "post";
      this.captcha_verified = false;
      fetch(apiUrl, {
        method: method_type,
        headers: {
          "content-type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({
          title: this.title,
          name: this.name,
          phone: this.phone,
          email: this.email,
          industry: this.industry,
          leadership: this.leadership,
          location: this.location,
          country: this.country,
          recaptcha: this.captch_response_token,
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.status === true) {
            this.$router.push("/success");
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              })
              .fire("Success", data.message, "success");
          } else if (data.status === false) {
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              })
              .fire("Error : ", data.message, "error");
          } else {
            this.errors = data.errors;
          }
          this.loader = false;
        })
        .catch(function (err) {
          console.log("Registration Error", "Error : " + err.message, "error");
        });
    },
  },
};
</script>